<template>
  <VehicleAutoComplete
    v-model="modelValue"
    itemName="number_plate"
    :error-messages="errorMessages"
    :filterAction="filterAction"
    :requestParams="{ type: 'filter' }"
  />
</template>
<script setup lang="ts">
import VehicleAutoComplete from "@/components/AutoCompletes/VehicleAutoComplete";
import getVehicleResponse from "@/types/responses/getVehicle";
import { computed } from "vue";

const props = defineProps<{
  modelValue: getVehicleResponse | undefined;
  errorMessages?: string[];
}>();

const emit = defineEmits(["update:modelValue"]);

const filterAction = (items: getVehicleResponse[]) => {
  return items.filter((item) => {
    return item.digital_tacograph;
  });
};

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
